import React, { useMemo } from 'react';
import { isCitiesAndKnightsContext } from '@colonist/i18n';
import { useUIGameEndContext } from '../../../../../contexts/UIGameEndContext.tsx';
import { useUIGameTranslationContext } from '../../../../../contexts/UIGameTranslationContext.tsx';
import { StatsTable } from '../../StatsTable/index.ts';
import { ACTIVITY_IMAGE_PATH, ACTIVITY_IMAGE_PATH_CK, ACTIVITY_TRANSLATION } from '../../../constants.ts';
export const ActivityStats = ()=>{
    const { gameEndData, playersByRank } = useUIGameEndContext();
    const { translationKeyContext } = useUIGameTranslationContext();
    const players = useMemo(()=>playersByRank.flatMap((player)=>player.color), [
        playersByRank
    ]);
    const headers = useMemo(()=>{
        const activityImagePath = isCitiesAndKnightsContext(translationKeyContext) ? ACTIVITY_IMAGE_PATH_CK : ACTIVITY_IMAGE_PATH;
        return Object.keys(activityImagePath).map((key)=>({
                imagePath: activityImagePath[key],
                tooltip: ACTIVITY_TRANSLATION[key].title
            }));
    }, [
        translationKeyContext
    ]);
    const rows = useMemo(()=>players.map((player)=>{
            const row = [];
            const data = gameEndData.endGameState.activityStats[player];
            if (data === undefined) return [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            row.push(data.proposedTrades);
            row.push(data.successfulTrades);
            row.push(data.resourcesUsed);
            row.push(data.resourceIncomeBlocked);
            row.push(data.devCardsBought);
            row.push(data.devCardsUsed);
            return row;
        }), [
        players
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StatsTable, {
        headers: headers,
        rows: rows
    }));
};
